import { render, staticRenderFns } from "./Packet.vue?vue&type=template&id=45302657&scoped=true"
import script from "./Packet.vue?vue&type=script&lang=js"
export * from "./Packet.vue?vue&type=script&lang=js"
import style0 from "./Packet.vue?vue&type=style&index=0&id=45302657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45302657",
  null
  
)

export default component.exports